import styled from 'styled-components';
import React, { ReactNode } from 'react';
export interface ArticleCardProps {
  children?: ReactNode;
  className?: string;
}

function ArticleCard({ children, className }: ArticleCardProps) {
  return <ArticleCardCss className={className}>{children}</ArticleCardCss>;
}

const ArticleCardCss = styled.div`
  background: ${p => p.theme.colors.white};
  padding: ${p => `${p.theme.sizes.spacing4}`};
`;

export default ArticleCard;
